import { create } from "zustand";

type NewSlidesState = {
  newSlides: Record<string, string[]>; // slideId -> element IDs to watch
  pendingFocusElementId: string | null;
  markAsNew: (slideId: string, elementIds: string[]) => void;
  markAsSeen: (slideId: string) => void;
  requestFocus: (elementId: string) => void;
  consumePendingFocus: (elementId: string) => boolean;
};

export const useNewSlidesStore = create<NewSlidesState>((set, get) => ({
  newSlides: {},
  pendingFocusElementId: null,
  markAsNew: (slideId, elementIds) =>
    set((state) => ({
      newSlides: { ...state.newSlides, [slideId]: elementIds },
    })),
  markAsSeen: (slideId) =>
    set((state) => {
      const { [slideId]: _omitted, ...rest } = state.newSlides;
      return { newSlides: rest };
    }),
  requestFocus: (elementId) => set({ pendingFocusElementId: elementId }),
  consumePendingFocus: (elementId) => {
    if (get().pendingFocusElementId !== elementId) return false;
    set({ pendingFocusElementId: null });
    return true;
  },
}));
